var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vias_white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f5f5f5;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-1",
    d: "M197.362,156a40.432,40.432,0,0,0-37.207,56.25H130.029V197.016a2.93,2.93,0,1,0-5.859,0V215.18a2.93,2.93,0,0,0,2.93,2.93h36.149a40.579,40.579,0,0,0,2.713,3.776c.047.067.094.135.146.2l25.251,32.353H177.625a2.93,2.93,0,0,0,0,5.859H217.19a2.93,2.93,0,0,0,0-5.859H203.362l25.394-32.546.029-.041A40.417,40.417,0,0,0,197.362,156Zm26.81,62.253-.105.135-26.7,34.219-26.432-33.864a3.043,3.043,0,0,0-.234-.325,34.57,34.57,0,1,1,53.475-.179Z",
    transform: "translate(-87.792 -110.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M338.925,230.626a2.93,2.93,0,0,0-5.566,1.8,18.164,18.164,0,1,1-12.39-11.912,2.93,2.93,0,0,0,1.562-5.649,24.024,24.024,0,1,0,16.406,15.762Z",
    transform: "translate(-206.489 -151.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-1",
    d: "M419.952,235.958l-.021-.029a2.929,2.929,0,1,0-4.143,4.143l.027.026a2.929,2.929,0,1,0,4.143-4.143Z",
    transform: "translate(-293.369 -166.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-1",
    d: "M68.651,420H2.93a2.93,2.93,0,0,0,0,5.859H65.722v18.164a2.93,2.93,0,1,0,5.859,0V422.93A2.93,2.93,0,0,0,68.651,420Z",
    transform: "translate(0 -296.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-1",
    d: "M53.461,0a2.93,2.93,0,0,0-2.93,2.93V24.023H2.93a2.93,2.93,0,0,0,0,5.859H53.461a2.93,2.93,0,0,0,2.93-2.93V2.93A2.93,2.93,0,0,0,53.461,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M26.151,154H3.93a2.93,2.93,0,1,0,0,5.859H23.222v50.977H3.93a2.93,2.93,0,1,0,0,5.859H26.151a2.93,2.93,0,0,0,2.93-2.93V156.93a2.93,2.93,0,0,0-2.93-2.93Z",
    transform: "translate(-0.707 -108.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M129.17,251.86a2.93,2.93,0,1,0,.858,2.071A2.929,2.929,0,0,0,129.17,251.86Z",
    transform: "translate(-87.791 -177.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M162.792,154H127.1a2.93,2.93,0,0,0-2.93,2.93v16.26a2.93,2.93,0,1,0,5.859,0v-13.33h32.763a2.93,2.93,0,1,0,0-5.859Z",
    transform: "translate(-87.792 -108.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M273.3,0a2.93,2.93,0,0,0-2.93,2.93V24.023H226.659V2.93a2.93,2.93,0,0,0-5.859,0V26.953a2.93,2.93,0,0,0,2.93,2.93H273.3a2.93,2.93,0,0,0,2.93-2.93V2.93A2.93,2.93,0,0,0,273.3,0Z",
    transform: "translate(-156.113 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M456.75,24.023H443.86V2.93a2.93,2.93,0,0,0-5.859,0V26.953a2.93,2.93,0,0,0,2.93,2.93h15.82a2.93,2.93,0,0,0,0-5.859Z",
    transform: "translate(-309.68 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M472.6,154H463.35a2.93,2.93,0,0,0,0,5.859H472.6a2.93,2.93,0,0,0,0-5.859Z",
    transform: "translate(-325.531 -108.883)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVias);
export default __webpack_public_path__ + "static/media/Vias.609883b17b134413ac3fa2618825e5e2.svg";
export { ForwardRef as ReactComponent };